
// eslint-disable-next-line
export const updateRecordInStore = (condition, results, newRecord) => (
  results.map(r => (condition(r) ? { ...r, ...newRecord } : r))
);

// eslint-disable-next-line
export const deleteRecordInStore = (condition, results) => (
  results.filter(r => condition(r))
);

export const createActionType = name => ({
  name,
  pending: `${name}_PENDING`,
  success: `${name}_FULFILLED`,
  error: `${name}_REJECTED`,
});
